import { useCallback, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import Shell from './components/Shell';
import LoginPage from './components/LoginPage';
import { useAuth } from './components/AuthProvider';
import Overview from './screens/Overview';
import Spaces from './screens/Spaces';
import People from './screens/People';
import Money from './screens/Money';
import Content from './screens/Content';
import Ops from './screens/Ops';

export default function App() {
  const { user, checking, isAdmin } = useAuth();
  const [days, setDays] = useState(30);
  /* Кнопка «пересчитать» меняет ключ — экраны перезапрашивают данные. */
  const [nonce, setNonce] = useState(0);
  const refresh = useCallback(() => setNonce((n) => n + 1), []);

  if (checking) return <div className="state boot"><span className="spin" /></div>;
  if (!user) return <LoginPage />;
  // Вошёл, но роли нет: бэкенд всё равно ответит 403, поэтому честнее сказать сразу.
  if (!isAdmin) return <LoginPage deniedFor={user.email} />;

  const props = { days, nonce };

  return (
    <>
      <Shell days={days} setDays={setDays} onRefresh={refresh}>
        <Routes>
          <Route path="/" element={<Overview {...props} />} />
          <Route path="/spaces" element={<Spaces {...props} />} />
          <Route path="/people" element={<People {...props} />} />
          <Route path="/money" element={<Money {...props} />} />
          <Route path="/content" element={<Content {...props} />} />
          <Route path="/ops" element={<Ops {...props} />} />
          <Route path="*" element={<Overview {...props} />} />
        </Routes>
      </Shell>
      <div className="tip" id="tip" />
    </>
  );
}
